module.exports = __webpack_public_path__ + "static/media/carousel3.583b33c2.jpg";